import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import request from '@/utils/request'
import { ElMessage } from 'element-plus'
import Layout from '@/views/Layout.vue'

import LoginView from '@/views/commons/LoginView.vue'
import RegisterView from '@/views/commons/RegisterView.vue'
import UpdatePassword from "@/views/commons/UpdatePassword.vue";

import HomeView from '@/views/HomeView.vue'
import Corp from "@/views/Corp.vue";

import UserChat from "@/views/UserChat.vue"
import CustomerService from "@/views/CustomerService.vue";

import PluginList from "@/views/PluginList.vue";
import PluginDetails from "@/views/PluginDetails.vue"
import PluginPricing from "@/views/PluginPricing.vue";
import Tutorial from "@/views/Tutorial.vue";

import ExePricing from "@/views/ExePricing.vue";

// import AdminDashboard from "@/views/manages/AdminDashboard.vue";
import UserManage from "@/views/manages/UserManage.vue"
import PluginManage from "@/views/manages/PluginManage.vue";
import OrderManage from "@/views/manages/OrderManage.vue";

import AccessLog from "@/views/logs/AccessLog.vue";

import Console from "@/views/Console.vue";
import Profile from "@/views/users/Profile.vue";

import UserProfileMain from "@/views/users/UserProfileMain.vue";
import UserProfilePlugins from "@/views/users/UserProfilePlugins.vue";
import UserProfileOrders from "@/views/users/UserProfileOrders.vue";

import AdminDashboard from "@/views/admin/AdminDashboard.vue";
import AdminUserManage from "@/views/admin/AdminUserManage.vue";
import AdminPluginManage from "@/views/admin/AdminPluginManage.vue";
import AdminOrderManage from "@/views/admin/AdminOrderManage.vue";

import UserAgreement from "@/views/commons/UserAgreement.vue";
import PrivacyPolicy from "@/views/commons/PrivacyPolicy.vue"

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: LoginView
      },
      {
        path: '/register',
        name: 'Register',
        component: RegisterView
      },
      {
        path: '/home',
        name: 'Home',
        component: HomeView
      },
      {
        path: '/pluginlist',
        name: 'pluginlist',
        component: PluginList
      },
      {
        path: '/console',
        name: 'console',
        component: Console,
        children: [
          {
            path: '/console/admindashboard',
            name: 'admindashboard',
            component: AdminDashboard
          },
          {
            path: '/console/profile',
            name: 'profile',
            component: Profile
          },
          {
            path: '/console/usermanage',
            name: 'usermanage',
            component: UserManage
          },
          {
            path: '/console/pluginmanage',
            name: 'pluginmanage',
            component: PluginManage
          },
          {
            path: '/console/ordermanage',
            name: 'ordermanage',
            component: OrderManage
          },
          {
            path: '/console/system/accesslog',
            name: 'accesslog',
            component: AccessLog
          }
        ]
      },
      {
        path: '/profile',
        name: 'profile',
        component: Profile,
        children: [
          {
            path: '/profile/UserProfileMain',
            name: 'userProfileMain',
            component: UserProfileMain
          },
          {
            path: '/profile/UserProfilePlugins',
            name: 'userProfilePlugins',
            component: UserProfilePlugins
          },
          {
            path: '/profile/UserProfileOrders',
            name: 'userProfileOrders',
            component: UserProfileOrders
          },
        ]
      },
      {
        path: '/products',
        name: 'products',
        component: PluginDetails
      },
      {
        path: '/corp',
        name: 'corp',
        component: Corp
      },
      {
        path: '/productPricing',
        name: 'productPricing',
        component: PluginPricing
      },
      {
        path: '/tutorial/:pluginTutorial',  // 动态参数
        name: 'tutorial',
        component: Tutorial,
        props: true,
        meta: { requiresAuth: false }
      },
      {
        path: '/customer-service',
        name: 'CustomerService',
        component: CustomerService,
        meta: { requiresAuth: true }
      },
      {
        path: '/user-chat',
        name: 'UserChat',
        component: UserChat
      },
      {
        path: '/updatePassword',
        name: 'updatePassword',
        component: UpdatePassword
      },
      {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        component: PrivacyPolicy
      },
      {
        path: '/userAgreement',
        name: 'userAgreement',
        component: UserAgreement
      },
    ]
  },
  {
    path: '/bind-phone',
    name: 'BindPhone',
    component: () => import('../views/commons/BindPhoneView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/exe/pricing',
    name: 'ExePricing',
    component: () => import('@/views/ExePricing.vue')
  },

  // 管理员路由

  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/AdminLoginPage.vue')
  },
  {
    path: '/admin/home',
    component: () => import('@/views/admin/AdminDashboardPage.vue'),
    redirect: '/admin/home/dashboard',
    meta: { requiresAdmin: true },
    children: [
      {
        path: '/admin/home/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard
      },
      {
        path: '/admin/home/users',
        name: 'AdminUserManage',
        component: AdminUserManage
      },
      {
        path: '/admin/home/plugins',
        name: 'AdminPluginManage',
        component: AdminPluginManage
      },
      {
        path: '/admin/home/orders',
        name: 'AdminOrderManage',
        component: AdminOrderManage
      },
      {
        path: '/admin/home/log/accesslog',
        name: 'AdminAccessLog',
        component: () => import('@/views/logs/AccessLog.vue')
      },
      {
        path: '/admin/home/log/usagelog',
        name: 'AdminUsageLog',
        component: () => import('@/views/logs/UsageLog.vue')
      }
    ]
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

// 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('auth_token');
//   const publicPages = [
//       '/', '/home','/corp','/userAgreement','/privacyPolicy',
//       '/pluginlist','/productPricing','/products',
//       '/login','/register','/bind-phone'
//   ];
//
//   const isPublicPage = publicPages.includes(to.path);
//
//   if (!token && !isPublicPage) {
//     // 如果token不存在且目标页面不是公开页面，则重定向到登录页
//     ElMessage.error('您还未登录，请先登录');
//
//     return next({
//       path: '/login',
//       query: { redirect: to.fullPath }  // 记录要跳转的页面
//     });
//   }
//
//   // 否则继续导航
//   next();
// })
// 路由守卫，添加访问统计 该该

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('auth_token');

  const isAdmin = localStorage.getItem('is_admin') === 'true';

  // 管理员路由检查
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    if (!token) {
      ElMessage.error('请先登录');
      return next('/admin/login');
    }

    if (!isAdmin) {
      ElMessage.error('需要管理员权限');
      return next('/admin/login');
    }
  }

  // 使用 meta 信息判断是否需要认证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  const publicPages = [
    '/', '/home','/corp','/userAgreement','/privacyPolicy',
    '/user-chat',
    '/pluginlist','/productPricing','/products','/iMessaging',
    '/admin/login',
    '/login','/register','/bind-phone','/updatePassword'
  ];

  const loginPages = [
    '/login', '/register', '/bind-phone', '/updatePassword',
    '/user-chat', '/customer-service',
    '/admin/login',
  ];

  const isPublicPage = publicPages.includes(to.path) ||
                                to.path.startsWith('/tutorial/') ||
                                to.path.startsWith('/exe/') ||
                                (to.meta && to.meta.requiresAuth === false);
  const isLoginPage = loginPages.includes(to.path);

  // 保存重定向路径到 sessionStorage
  if (!isLoginPage){
    sessionStorage.setItem('redirect_path', to.fullPath);
  }

  if (!token && !isPublicPage) {
    ElMessage.error('您还未登录，请先登录');

    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  }

  // 重置发送状态
  sessionStorage.setItem('is_sending_log', 'false');

  // 记录离开上一个页面的时间
  const currentVisitStr = sessionStorage.getItem('current_visit');

  if (currentVisitStr && from && from.path !== '/') {
    const currentVisit = JSON.parse(currentVisitStr);
    const leaveTime = Date.now();
    const duration = leaveTime - currentVisit.enterTime;

    // 发送上一个页面的访问日志
    request.post('/log/page-track', {
      ...currentVisit,
      duration: duration
    }).catch(err => {
      console.error('访问日志记录失败:', err);
    });

    sessionStorage.removeItem('current_visit');
  }

  // 设置新页面的访问信息
  let referrer = '';
  if (!from || !from.path || from.path === '/') {
    referrer = document.referrer || '直接访问';
  } else {
    referrer = window.location.origin + from.fullPath;
  }

  // 生成服务器本地时间格式的字符串
  const now = new Date();
  const serverTimeStr = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + ' ' +
      String(now.getHours()).padStart(2, '0') + ':' +
      String(now.getMinutes()).padStart(2, '0') + ':' +
      String(now.getSeconds()).padStart(2, '0') + '.' +
      String(now.getMilliseconds()).padStart(6, '0');

  const visitData = {
    page: to.fullPath,
    referrer: referrer,
    userAgent: navigator.userAgent,
    timestamp:  serverTimeStr,  // 使用服务器本地时间格式
    enterTime: Date.now()
  };

  sessionStorage.setItem('current_visit', JSON.stringify(visitData));

  next();
});

export default router